import { useCallback } from 'react';
import { processRowToProduct } from '../CSVImportHelper';
import { ProductData, FieldMapping } from '../CSVTypes';

export const useProcessRowToProduct = () => {
    const processRow = useCallback((row: Record<string, string>, selectedMappings: FieldMapping[]): ProductData => {
        return processRowToProduct(row, selectedMappings);
    }, []);

    return { processRowToProduct: processRow };
};
